import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserSubscription, UserSubscriptionType} from "../../../user/user-subscription";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";
import {User} from "../../../user/user";
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {getCurrencySymbol, isCurrencySymbol} from "../../../shared/utils/currency-symbols";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    selector: 'db-billing-info',
    templateUrl: './db-billing-info.component.html',
    styleUrls: ['./db-billing-info.component.scss'],
    standalone: false
})
export class DbBillingInfoComponent implements OnInit, OnDestroy {

  @Input() userSubscription: UserSubscription;
  @Input() user: User;
  public userSubscriptionStatus: any = UserSubscriptionStatus;
  public UserSubscriptionType: any = UserSubscriptionType;
  public currencySymbol: string = '$';
  public isCurrencyBeforeAmount: boolean = true;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  ngOnInit() {
    this._getCompanyInfo();
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getCompanyInfo)),
        takeUntil(this._destroyStream$)
      )
      .subscribe((companyInfo: any) => {
        this.currencySymbol = getCurrencySymbol(companyInfo?.agency?.currency);
        this.isCurrencyBeforeAmount = isCurrencySymbol(this.currencySymbol);
      });
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

}
